import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import FinancialProjections from './pages/financial-projections';
import RVParkCalculator from './pages/rv-park-calculator';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here - Start with calculator as default */}
        <Route path="/" element={<RVParkCalculator />} />
        <Route path="/rv-park-calculator" element={<RVParkCalculator />} />
        <Route path="/financial-projections" element={<FinancialProjections />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;